import TicketList from './tickets-list';

export default TicketList;
